<div cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
  <form [formGroup]="userInputForm" (ngSubmit)="onSubmit()" class="form-wrapper">
    <mat-dialog-content class="mat-typography" #dialogContent>
      <div class="instruction-prompt">
        <strong>AI Prompt:</strong>
        <div>"{{instruction.details.prompt}}"</div>
      </div>
      <mat-form-field class="input-field">
        <mat-label>{{label}}</mat-label>
        <input matInput formControlName="userInput" required/>
        @if (userInputForm.invalid) {
          <mat-error>Your input is required.</mat-error>
        }
      </mat-form-field>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button type="button" matButton (click)="cancel()">{{cancelButtonText}}</button>
      <button type="submit" matButton="filled" class="btn-confirm">Submit</button>
    </mat-dialog-actions>
  </form>
</div>
